export default import.meta.ROLLUP_FILE_URL_SV35$zogRPv38DnAnhVtpA